angular.module('files')
    .factory('FileUploaderCustom', function ($rootScope, $filter, toastr, $cookies, FileUploader) {
        function create(url, formDataFn, onComplete, settings) {
            let executeOnComplete = onComplete || angular.noop;
            let uploadSettings = {
                url: url,
                headers: {
                    "X-Requested-With": 'XMLHttpRequest',
                    "X-CSRF-TOKEN": $cookies.get("CSRF-TOKEN")
                }
            };
            if (settings?.multiple !== true) {
                uploadSettings.queueLimit = 1
            }
            if (settings?.autoUpload) {
                uploadSettings.autoUpload = settings.autoUpload
            }
            if(settings?.removeAfterUpload) {
                uploadSettings.removeAfterUpload = settings.removeAfterUpload
            }

            let uploader = new FileUploader(uploadSettings)

            if (settings?.multiple !== true) {
                uploader.onWhenAddingFileFailed = (item /*{File|FileLikeObject}*/, filter, options) => {
                    toastr.error("Nie udało się dodać pliku. Możesz dodać tylko jeden plik", "Błąd");
                }
            }
            if (angular.isArray(settings?.filters)) {
                settings?.filters.forEach(filter => uploader.filters.push(filter))
            }
            uploader.onWhenAddingFileFailed = (item /*{File|FileLikeObject}*/, filter, options) => {
                toastr.error("Nie można dodać pliku. Powód: " + filter.name, "Błąd");
            }

            uploader.onSuccessItem = (fileItem, response, status, headers) => {
                fileItem.uploadResult = response;
            }

            uploader.onErrorItem = (fileItem, response, status, headers) => {
                if (angular.isDefined(response.messages)) {
                    toastr.error(response.messages[0], "Błąd wysyłania pliku " + fileItem.file.name);
                } else {
                    toastr.error("Błąd wysyłania pliku " + fileItem.file.name);
                }
            }

            uploader.onCancelItem = (fileItem, response, status, headers) => {
                toastr.warning("Anulowano wysyłanie pliku " + fileItem.file.name, "Anulowanie");
            }

            uploader.onCompleteAll = result => {
                if (uploader.getNotUploadedItems().length === 0) {
                    toastr.success("Przesyłanie zakończone", "Wszystkie pliki wysłane");
                    executeOnComplete(uploader.queue.map(file => file.uploadResult));
                } else {
                    toastr.warning("Nie wszystkie pliki zostały poprawnie wysłane na serwer", "UWAGA!", {
                        closeButton: true,
                        timeOut: 10000
                    });
                }
                $rootScope.$broadcast('file.saved');
            }

            uploader.onBeforeUploadItem = item => {
                let uploadFormData = {
                    // isLinkActive: true,
                    // isAssignable: false
                };
                angular.extend(uploadFormData, formDataFn());
                item.formData.push(uploadFormData);
            }
            return uploader
        }

        return {
            create: create
        };
    })
    .factory('FileUploaderLocal', function ($rootScope, $filter, $q, toastr, $cookies, FileUploader) {

        function create(formDataFn, onComplete) {

            let executeOnComplete = onComplete || angular.noop
            let url = formDataFn().type ? '/crm/api/file-association-' + $filter('lowercase')(formDataFn().type) : '/crm/api/files'

            let uploader = new FileUploader({
                url: url,
                headers: {
                    "X-Requested-With": 'XMLHttpRequest',
                    "X-CSRF-TOKEN": $cookies.get("CSRF-TOKEN")
                }
            })

            if (angular.isArray(formDataFn().filters)) {
                formDataFn().filters.forEach(filter => uploader.filters.push(filter))
            }

            // uploader.filters.push({
            //     name: 'Filtr PDF',
            //     fn: function(item /*{File|FileLikeObject}*/, options) {
            //         var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
            //         return '|pdf|'.indexOf(type) !== -1;
            //     }
            // });

            uploader.onWhenAddingFileFailed = (item /*{File|FileLikeObject}*/, filter, options) => {
                toastr.error("Nie można dodać pliku. Powód: " + filter.name, "Błąd");
            }

            uploader.onSuccessItem = (fileItem, response, status, headers) => {
                fileItem.crmfile = response;
            }

            uploader.onErrorItem = (fileItem, response, status, headers) => {
                fileItem.isUploaded = false;
                if (angular.isDefined(response.messages)) {
                    toastr.error(response.messages[0], "Błąd wysyłania pliku " + fileItem.file.name);
                } else {
                    toastr.error("Błąd wysyłania pliku " + fileItem.file.name);
                }
            }

            uploader.onCancelItem = (fileItem, response, status, headers) => {
                toastr.warning("Anulowano wysyłanie pliku " + fileItem.file.name, "Anulowanie");
            }

            uploader.onCompleteAll = () => {
                if (uploader.getNotUploadedItems().length === 0) {
                    toastr.success("Przesyłanie zakończone", "Wszystkie pliki wysłane");
                    executeOnComplete(uploader.queue.map(file => file.crmfile));
                } else {
                    toastr.warning("Nie wszystkie pliki zostały poprawnie wysłane na serwer", "UWAGA!", {
                        closeButton: true,
                        timeOut: 10000
                    });
                }
                $rootScope.$broadcast('file.saved');
            }

            uploader.onBeforeUploadItem = item => {
                let uploadFormData = {
                    // isLinkActive: true,
                    // isAssignable: false
                };
                angular.extend(uploadFormData, formDataFn());
                item.formData.push(uploadFormData);
            }
            return uploader
        }

        function uploadOne(uploader) {
            const item = uploader && uploader.queue && uploader.queue[0]
            if (!item) {
                return $q.reject({message: 'Nie wybrano pliku'})
            }
            if (item.crmfile) {
                return $q.resolve(item.crmfile)
            }

            const deferred = $q.defer()
            const previousCompleteItem = uploader.onCompleteItem || angular.noop
            uploader.onCompleteItem = (fileItem, response, status, headers) => {
                previousCompleteItem(fileItem, response, status, headers)
                if (fileItem !== item) {
                    return
                }
                uploader.onCompleteItem = previousCompleteItem
                if (fileItem.isSuccess && fileItem.crmfile) {
                    deferred.resolve(fileItem.crmfile)
                    return
                }
                deferred.reject({data: response, status: status})
            }
            item.upload()
            return deferred.promise
        }

        function uploadAll(uploader) {
            if (!uploader || !uploader.queue) {
                return $q.reject({message: 'Nie skonfigurowano wysyłania plików'})
            }
            if (uploader.getNotUploadedItems().length === 0) {
                return $q.resolve(uploader.queue.map(item => item.crmfile).filter(file => file != null))
            }

            const deferred = $q.defer()
            const previousCompleteAll = uploader.onCompleteAll || angular.noop
            uploader.onCompleteAll = () => {
                uploader.onCompleteAll = previousCompleteAll
                previousCompleteAll()

                const hasFailedUpload = uploader.queue.some(item => !item.isSuccess || !item.crmfile)
                if (hasFailedUpload) {
                    deferred.reject({message: 'Nie wszystkie pliki zostały zapisane'})
                    return
                }
                deferred.resolve(uploader.queue.map(item => item.crmfile))
            }
            uploader.uploadAll()
            return deferred.promise
        }

        return {
            create: create,
            uploadOne: uploadOne,
            uploadAll: uploadAll
        };
    })
    .directive('filePaste', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                const getUploader = $parse(attrs.filePaste)
                const onPaste = event => {
                    const nativeEvent = event.originalEvent || event
                    const clipboardData = nativeEvent.clipboardData
                    const uploader = getUploader(scope)
                    if (!clipboardData || !uploader) {
                        return
                    }
                    const filesFromItems = Array.from(clipboardData.items || [])
                        .filter(item => item.kind === 'file')
                        .map(item => item.getAsFile())
                        .filter(file => file != null)
                    const files = filesFromItems.length > 0
                        ? filesFromItems
                        : Array.from(clipboardData.files || [])
                    if (files.length === 0) {
                        return
                    }
                    event.preventDefault()
                    scope.$applyAsync(() => uploader.addToQueue(files))
                }

                element.on('paste', onPaste)
                scope.$on('$destroy', () => element.off('paste', onPaste))
            }
        }
    })
    .component('fileUpload', {
        require: {
            ngModelController: 'ngModel'
        },
        bindings: {
            api: '<',
            description: '@',
            uploadData: '<',
            inputId: '@',
            ariaLabel: '@',
            accept: '@',
            isRequired: '<',
            isDisabled: '<'
        },
        templateUrl: 'app/files/file-upload.html',
        controller: function ($scope, $q, FileUploaderLocal) {
            this.$onInit = () => {
                this.resolvedInputId = this.inputId || 'file-upload-' + $scope.$id
                this.uploader = FileUploaderLocal.create(() => {
                    const uploadData = angular.extend({}, this.uploadData || {})
                    if (angular.isDefined(this.description)) {
                        uploadData.description = this.description
                    }
                    return uploadData
                })
                this.configureUploader()
                this.configureValidation()
                this.configureApi()
            }

            this.$onChanges = changes => {
                if (changes.isRequired && this.ngModelController) {
                    this.ngModelController.$validate()
                }
            }

            this.$onDestroy = () => {
                if (this.isLocalFile(this.ngModelController.$viewValue)) {
                    this.ngModelController.$setViewValue(null)
                }
                if (this.api && this.api.upload === this.upload) {
                    delete this.api.upload
                    delete this.api.clear
                    delete this.api.hasPendingFile
                }
            }

            this.configureUploader = () => {
                const previousAfterAddingFile = this.uploader.onAfterAddingFile || angular.noop
                this.uploader.onAfterAddingFile = item => {
                    previousAfterAddingFile(item)
                    if (this.isDisabled) {
                        item.remove()
                        return
                    }
                    this.uploader.queue
                        .filter(queuedItem => queuedItem !== item)
                        .forEach(queuedItem => queuedItem.remove())
                    $scope.$evalAsync(() => {
                        this.ngModelController.$setViewValue({
                            $localFile: true,
                            name: item.file.name,
                            size: item.file.size
                        })
                        this.ngModelController.$setTouched()
                    })
                }
            }

            this.configureValidation = () => {
                this.ngModelController.$validators.required = (modelValue, viewValue) =>
                    !this.isRequired || !this.ngModelController.$isEmpty(viewValue)
                this.ngModelController.$validate()
            }

            this.configureApi = () => {
                if (!this.api) {
                    return
                }
                this.api.upload = this.upload
                this.api.clear = this.clear
                this.api.hasPendingFile = this.hasPendingFile
            }

            this.isLocalFile = file => !!file?.$localFile
            this.fileItem = () => this.uploader?.queue?.[0] || null
            this.persistedFile = () => {
                const file = this.ngModelController.$viewValue
                return file && !this.isLocalFile(file) ? file : null
            }
            this.hasFile = () => !this.ngModelController.$isEmpty(this.ngModelController.$viewValue)
            this.hasPendingFile = () => {
                const item = this.fileItem()
                return !!item && !item.crmfile
            }

            this.upload = () => {
                const item = this.fileItem()
                if (!item) {
                    return $q.resolve(this.persistedFile())
                }
                return FileUploaderLocal.uploadOne(this.uploader).then(file => {
                    item.remove()
                    this.ngModelController.$setViewValue(file)
                    this.ngModelController.$render()
                    return file
                })
            }

            this.clear = () => {
                this.uploader.queue.slice().forEach(item => item.remove())
                this.ngModelController.$setViewValue(null)
                this.ngModelController.$setTouched()
            }
        }
    })
